export const EMPTY_CELL_PREFIX = 'cell-null';
export const FAILED_CELL_PREFIX = 'cell-failed';
export const DRAFT_COL_PREFIX = 'col-draft';
export const PUBLISHED_COL_PREFIX = 'col-published';
